<template>
  <div class="liu">
    <!-- title -->
    <mt-header fixed title="余额明细" class="title2">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <!-- 正文 -->
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <div class="task-detail-table header-next" v-for="(item, index) in myData.list" :key="index">
        <div class="detail-table-bodyer">
          <div class="detail-title">
            <span class="title">{{ item.content }}</span>
            <span class="money">{{ item.money }}</span>
          </div>
          <div class="detail-date">
            <span class="date">{{ item.insertDate }}</span>
            <span class="money">{{ item.postMoney | num }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT */

import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { GetAgentMoneyLog } from '@/api/user';

export default {
  name: 'TaskRewardDetail',
  data() {
    return {
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
      // 列表信息
      myData: {
        list: [],
        total: -1,
        scrollDisabled: true,
      },
      // 查询参数
      myParam: {
        lastId: 0,
        pageSize: 10,
        startDate: '',
        endDate: '',
        productAgentId: '',
        jyUserMoneyKey: '003',
        payTrueType: 1,
        moneyType: 2,
      },
    };
  },
  mounted() {
    this.initData();
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.getMyData();
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      this.myParam.startDate = `${this.$route.query.date} 00:00:00`;
      this.myParam.endDate = `${this.$route.query.date} 23:59:59`;
      this.myParam.productAgentId = this.$route.query.productagentid;
      GetAgentMoneyLog(this.myParam)
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.myData.total = res.total;
              this.myData.list.push(...res.rows);
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          this.myData.total = -1;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        const len = this.myData.list.length;
        this.myParam.lastId = this.myData.list[len - 1].id;
        this.getMyData();
      }
    },
  },
  filters: {
    num(val) {
      return `${val.toString().substring(0, val.toString().length - 2)}.${val.toString().substr(-2)}`;
    },
  },
};
</script>
